import type { SpecificationGenContentState } from '../../types/specification-gen-content';

import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { SpecificationGenContentModel } from '../specification-gen-content-model';

@injectable()
export class SpecificationGenContentModelImpl extends AbstractModel<SpecificationGenContentState> implements SpecificationGenContentModel {
    protected _modelData: SpecificationGenContentState = {
        taskId: '',
        generatedContent: {
            status: null,
            content: [],
        },
    };

    get modelData(): SpecificationGenContentState {
        return this._modelData;
    }
}

